import React from "react";
import Dashboard from "./Dashboard";

// Usa la misma vista moderna de Lines, restringida exclusivamente a apuestas de palé.
const DashboardPale = () => <Dashboard paleOnly />;

export default DashboardPale;
